import { createPlatformStyles, theme } from "../../theme/theme";
export const { ids, styles } = createPlatformStyles({
  mobile: {
    topParentView: {
      backgroundColor: theme.colors.primary,
      overflow: "hidden",

      flex: 1,
    },
  },
  web: {
    topParentView: {
      backgroundColor: theme.colors.primary,
      overflow: "hidden",
      flex: 1,
    },
  },
});
